const LONG_MONTH_STRINGS_EN = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const SHORT_MONTH_STRINGS_EN = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const LONG_DAY_OF_WEEKS_EN = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

const SHORT_DAY_OF_WEEKS_JA = [
  "日",
  "月",
  "火",
  "水",
  "木",
  "金",
  "土"
];

const SHORT_DAY_OF_WEEKS_EN = [
	'Sun',
	'Mon',
	'Tue',
	'Wed',
	'Thu',
	'Fri',
	'Sat',
];


/**
 * 月のローカライズ。
 * @param month_no 月番号(Date.getMonth()と同等の番号。0が1月。)
 * @returns ローカライズされた月。
 */
export function getLongMonthString(month_no: number)
{
  // 日本語
  return (month_no+1) + '月';

  // todo takezawa 英語に対応する。
  // return LONG_MONTH_STRINGS_EN[month_no];
}
export function getShortMonthString(month_no: number)
{
  // 日本語
  return (month_no+1) + '月';

  // todo takezawa 英語に対応する。
  // return SHORT_MONTH_STRINGS_EN[month_no];
}

/**
 * 日のローカライズ。
 * @param day 日。（1は1日）
 * @returns ローカライズされた日。
 */
export function getDayString(day: number)
{
  // 日本語
  return day + '日';

  // todo takezawa 英語に対応する。
}

/**
 * 曜日のローカライズ。
 * @param day_of_week_no 曜日番号 （0は日曜日）
 * @returns ローカライズされた日。
 */
export function getShortDayOfWeekString(day_of_week: number)
{
  return SHORT_DAY_OF_WEEKS_JA[day_of_week];

  // todo takezawa 英語に対応する。
}

/**
 * 曜日のローカライズ。()カッコ付き
 * @param day_of_week 
 * @returns 
 */
export function getShortDayOfWeekStringParen(day_of_week: number)
{
  return '(' + getShortDayOfWeekString(day_of_week) + ')';
}


export default {
  getLongMonthString,
  getShortMonthString,
  getDayString,
  getShortDayOfWeekString,
  getShortDayOfWeekStringParen,
}
